import BaseQuestionCard from '../BaseQuestionCard'
import SurveyDateIcon from '../SurveyDateIcon'
import { QUESTION_CARD_VARIANTS, SURVEY_TYPES } from '../constants/constantsSurveys'

export default function DateQuestionCard(props) {
  return (
    <BaseQuestionCard
      {...props}
      {...QUESTION_CARD_VARIANTS[SURVEY_TYPES.date]}
      answerEndAdornment={<SurveyDateIcon />}
    />
  )
}
